var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Numbers"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(0,0,0)",
    fontFamily: "ArialMT, Arial",
    fontSize: 18,
    transform: "translate(31.995 -762.544)"
  }, "4", /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 124
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 248
  }, "24"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 372
  }, "34"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 496
  }, "44"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 620
  }, "54"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 744
  }, "64"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 868
  }, "74"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 992
  }, "84"), /*#__PURE__*/React.createElement("tspan", {
    x: -5.005,
    y: 1116
  }, "94"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1240
  }, "104"), /*#__PURE__*/React.createElement("tspan", {
    letterSpacing: "-.074em",
    x: -9.343,
    y: 1364
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: -0.668,
    y: 1364
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1488
  }, "124"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1612
  }, "134"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1736
  }, "144"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1860
  }, "154"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 1984
  }, "164"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2108
  }, "174"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2232
  }, "184"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2356
  }, "194"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2480
  }, "204"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2604
  }, "214"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2728
  }, "224"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2852
  }, "234"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 2976
  }, "244"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3100
  }, "254"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3224
  }, "264"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3348
  }, "274"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3472
  }, "284"), /*#__PURE__*/React.createElement("tspan", {
    x: -10.011,
    y: 3596
  }, "294")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_2_PT",
    "data-name": "2 PT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.235 62h-47.235a1 1 0 0 1 -1-1v-.654a30.321 30.321 0 0 1 22.85-29.429l.492 1.938a28.321 28.321 0 0 0 -21.342 27.145h46.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.835 50.122a28.457 28.457 0 0 0 -19.443-17.266l.492-1.938a30.46 30.46 0 0 1 20.816 18.482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.369 34.743a16.146 16.146 0 1 1 16.146-16.143 16.164 16.164 0 0 1 -16.146 16.143zm0-30.292a14.146 14.146 0 1 0 14.146 14.149 14.162 14.162 0 0 0 -14.146-14.149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.578 71.549a11.412 11.412 0 1 1 11.422-11.412 11.425 11.425 0 0 1 -11.422 11.412zm0-20.824a9.412 9.412 0 1 0 9.422 9.412 9.422 9.422 0 0 0 -9.422-9.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.583 55.124h2v10.026h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.57 59.137h10.026v2h-10.026z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.6a397fa4a4fe823a252604943710354f.svg";
export { ForwardRef as ReactComponent };